import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField, Modal } from '@mui/material'
import { RootState } from '../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import DialogTitle from '@mui/material/DialogTitle'
import { getITAdminStateData } from '../../actions'
import { useStyles } from './SettingsStyles'
import { UpdateITAdminStateData } from '../../actions/api/fetchITAdmin'
import { getITAdminSettingsData } from '../../actions'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { DialogContentText } from '@mui/material'

export default function EditStateCodeDialog({ open, handleClose, params }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [stateCode, setStateCode] = useState('')
  const [stateName, setStateName] = useState('')
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [stateCodeChanged, setstateCodeChanged] = useState(false)
  const [stateNameChanged, setstateNameChanged] = useState(false)
  const [descriptionChanged, setDescriptionChanged] = useState(false)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [disableSubmit, setDisableSubmit] = useState(true)
  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn}`)
  const { edit_state_success, edit_state_error } = useSelector((state: RootState) => state.editStateResponse)

  useEffect(() => {
    setStateCode(params.state_code)
    setStateName(params.state_name)
  }, [params.state_code, params.state_name])

  const handleCloseDialog = (type) => {
    if (type === 'confirm') {
      setstateCodeChanged(false)
      setstateNameChanged(false)
      setDisableSubmit(true)
    }
    setOpenDialog(false)
  }
  const onCancel = (e) => {
    if (stateCodeChanged || stateNameChanged) {
      setOpenDialog(true)
    } else {
      handleClose()
    }
  }

  const onChangeData = (e, type) => {
    setDisableSubmit(false)
    if (type === 'stateCode') {
      setStateCode(e.target.value.trim())
      if (e.target.value === '') {
        setDisableSubmit(true)
      } else {
        setDisableSubmit(false)
      }
      setstateCodeChanged(true)
    } else if (type === 'stateName') {
      setStateName(e.target.value.trim())
      if (e.target.value === '') {
        setDisableSubmit(true)
      } else {
        setDisableSubmit(false)
      }
      setstateNameChanged(true)
    }
  }

  useEffect(() => {
    if (stateCodeChanged || stateNameChanged) {
      dispatch(getITAdminStateData())
      setDisableSubmit(false)
    }
  }, [stateNameChanged, stateCodeChanged])

  const handleSubmit = async () => {
    const EditParameters = {
      id: params.id.toString(),
      state_name: stateName.trim(),
      state_code: stateCode.trim(),
    }
    await dispatch(UpdateITAdminStateData({ payload: EditParameters }))
    await setOpenSuccessSnackBar(true)
    await dispatch(getITAdminStateData())
    await updateDataTable()
  }

  const updateDataTable = () => {
    setTimeout(closeModal, 100)
    setStateCode('')
    setStateName('')
    setstateCodeChanged(false)
    setstateCodeChanged(false)
    setDescriptionChanged(false)
    setDisableSubmit(true)
    handleClose()
  }

  const closeModal = handleClose
  const SuccessMessage = `Edit State Code operation successful`
  const ErrorMessage = `Edit State Code operation failed`
  return (
    <React.Fragment>
      <div>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              You have pending unsaved changes. Do you really want to discard them?
            </DialogContentText>
          </DialogContent>

          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.btn} ${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('confirm')
                handleClose()
              }}
              autoFocus
              endIcon={<CheckIcon />}
            >
              Confirm
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('cancel')
              }}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        {edit_state_success && openSuccessSnackBar && <SuccessSnackBar message={SuccessMessage} />}
        {edit_state_error && openSuccessSnackBar && <ErrorSnackBar message={ErrorMessage} />}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className={`${classes.mt} , ${classes.mb}`}>
            <Dialog
              fullWidth
              maxWidth="sm"
              id="hello"
              classes={{ paper: classes.dialogHeight }}
              open={open}
              onClose={handleClose}
            >
              <DialogTitle className={classes.dialogTitle}>Edit State Code</DialogTitle>
              <Divider />
              <DialogContent>
                <Box component="form" autoComplete="off">
                  <div className={classes.TextField}>
                    <TextField
                      className={classes.TextBox}
                      label="State Code*"
                      type="string"
                      variant="outlined"
                      placeholder="max four characters"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                        maxLength: 4,
                      }}
                      onKeyPress={(e) => {
                        if (!/[a-za-z.]/i.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onChange={(event) => onChangeData(event, 'stateCode')}
                      defaultValue={params.state_code.trim()}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      className={classes.TextBox}
                      label="State Name*"
                      type="string"
                      variant="outlined"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                      }}
                      onChange={(event) => onChangeData(event, 'stateName')}
                      defaultValue={params.state_name}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </Box>
              </DialogContent>
              <DialogActions className={classes.buttonActions}>
                <Button onClick={handleSubmit} className={getClassNames()} endIcon={<CheckIcon />}>
                  Submit
                </Button>
                <Button
                  onClick={onCancel}
                  color="primary"
                  variant="outlined"
                  style={{ width: '115px' }}
                  endIcon={<ClearIcon />}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  )
}
